// utils/pagination.js

/**
 * Computes the total number of pages based on:
 * - totalRecords (the count your UI/store knows about)
 * - pageSize (messages per page)
 * - nextPageUrl (null means the server confirms we are on the last page)
 *
 * If nextPageUrl === null:
 *    → Use Math.floor (we only count pages that actually exist)
 *
 * If nextPageUrl !== null:
 *    → Use Math.ceil (reserve space for pages the server says exist)
 *
 * Always returns at least 1.
 */
export function computeTotalPages(totalRecords = 0, pageSize = 10) {
    if (!pageSize || pageSize <= 0) return 1;
    return Math.max(1, Math.ceil(totalRecords / pageSize));
}


/**
 * Ensures the page number stays within valid bounds.
 * Useful when totalPages changes due to new messages arriving.
 */
export function clampPage(page, totalPages) {
    return Math.max(1, Math.min(totalPages, page));
}

/**
 * Convenience helper — computes both current page and total pages safely.
 * Useful for reducers or components that need a clean derived state object.
 */
export function derivePaginationState({ currentPage, totalRecords, pageSize, nextPageUrl }) {
    const totalPages = computeTotalPages(totalRecords, pageSize, nextPageUrl);
    return {
        totalPages,
        currentPage: clampPage(currentPage, totalPages),
    };
}
